import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import actions from './actions';
import ListaAcoes from '../../components/ListaAcoes';

import constants from './constants';

class ListaWebhookLeitura extends Component {
  render() {
    let { value, actions } = this.props;

    return (
      <ListaAcoes
        title="Webhook Leitura"
        value={value}
        actions={{
          onLoad: () => {},
          onCancel: actions.onChangeListWebhook(
            constants.Status.CANCELADA, 'read'
          ),
          onApprove: actions.onChangeListWebhook(
            constants.Status.CONFIRMADA, 'read'
          ),
          onCreate: actions.onChangeListWebhook(
            constants.Status.CONFIRMADA, 'read'
          )
        }}
        labelFn={item => <details>
          <summary>{item.user_namespace_name} / {item.user_name}<br />{item.event_name}</summary>
          <ul>
            <li>Namespace : {item.user_namespace_count} - {constants.StatusLabel(item.user_namespace_status)}</li>
            <li>User : {item.user_count} - {constants.StatusLabel(item.user_status)}</li>
            <li>Event : {item.event_count} - {constants.StatusLabel(item.event_status)}</li>
          </ul>
          </details>}
      />
    );
  }
}

let mapStateToProps = ({ admin: { typeEventUsers } }) => ({
  value: {
    ...typeEventUsers,
    result: typeEventUsers.result.map(v => ({
      ...v,
      status: v.status_read
    }))
  }
});

let mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ListaWebhookLeitura);



// WEBPACK FOOTER //
// ./src/modules/admin/ListaWebhookLeitura.js